
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  }
};
